"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _core = _interopRequireDefault(require("./core"));
var _logger = _interopRequireDefault(require("../logger"));
var _uuid = require("uuid");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Regula = exports["default"] = /*#__PURE__*/function (_Core) {
  function Regula(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Regula);
    _this = _callSuper(this, Regula, [props]);
    _this.connection = props.connection;
    _this.appName = props.appName;
    _this.on = _this.on.bind(_this);
    _this._events = {};
    _this.ready = false;
    _this.myServices = ["regula"];
    _this.documentChunks = {};
    _this.init();
    return _this;
  }
  (0, _inherits2["default"])(Regula, _Core);
  return (0, _createClass2["default"])(Regula, [{
    key: "handleMessage",
    value: function () {
      var _handleMessage = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(message) {
        var action, data, parsedData;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(message.origin === 'sdk-' + this.appName)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              action = message.action, data = message.data;
              _context.t0 = action;
              _context.next = _context.t0 === 'System.Regula.OpticalChange' ? 6 : _context.t0 === 'Systems.Regula.ReadNotifications' ? 7 : _context.t0 === 'System.Regula.Enable.Response' ? 9 : _context.t0 === 'System.Regula.Disable.Response' ? 9 : _context.t0 === 'System.Regula.CheckStatus.Response' ? 9 : 12;
              break;
            case 6:
              this.trigger('opticalChange', data);
            case 7:
              // Handle document scanning with chunking
              this.handleDocumentScan(data);
              return _context.abrupt("return");
            case 9:
              parsedData = JSON.parse(data);
              this.trigger(action.split('.')[2].toLowerCase(), parsedData);
              return _context.abrupt("return");
            case 12:
              return _context.abrupt("break", 13);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleMessage(_x) {
        return _handleMessage.apply(this, arguments);
      }
      return handleMessage;
    }()
  }, {
    key: "enableDevice",
    value: function () {
      var _enableDevice = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var payload;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              payload = {
                uuid: (0, _uuid.v4)(),
                action: "System.Regula.Enable",
                origin: "sdk-" + this.appName
              };
              _context2.next = 3;
              return this.connection.invoke('messaging', payload);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function enableDevice() {
        return _enableDevice.apply(this, arguments);
      }
      return enableDevice;
    }()
  }, {
    key: "disableDevice",
    value: function () {
      var _disableDevice = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var payload;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              payload = {
                uuid: (0, _uuid.v4)(),
                action: "System.Regula.Disable",
                origin: "sdk-" + this.appName
              };
              _context3.next = 3;
              return this.connection.invoke('messaging', payload);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function disableDevice() {
        return _disableDevice.apply(this, arguments);
      }
      return disableDevice;
    }()
  }, {
    key: "checkDeviceStatus",
    value: function () {
      var _checkDeviceStatus = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        var payload;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              payload = {
                uuid: (0, _uuid.v4)(),
                action: "System.Regula.CheckStatus",
                origin: "sdk-" + this.appName
              };
              _context4.next = 3;
              return this.connection.invoke('messaging', payload);
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function checkDeviceStatus() {
        return _checkDeviceStatus.apply(this, arguments);
      }
      return checkDeviceStatus;
    }()
  }, {
    key: "handleDocumentScan",
    value: function () {
      var _handleDocumentScan = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(newData) {
        var data, currentChunk, readUUID, resultData, totalChunks, fullData;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              // Validate the essential data structure
              data = JSON.parse(newData);
              if (!(!data || (0, _typeof2["default"])(data) !== 'object' || data.currentChunk === undefined || !data.readUUID || !data.resultData || data.totalChunks === undefined)) {
                _context5.next = 4;
                break;
              }
              console.error('Invalid or incomplete data received:', data);
              return _context5.abrupt("return");
            case 4:
              currentChunk = data.currentChunk, readUUID = data.readUUID, resultData = data.resultData, totalChunks = data.totalChunks; // Initialize the storage for chunks per document if not already done
              this.documentChunks = this.documentChunks || {};
              // Initialize the array with null values to ensure all indexes are pre-defined
              this.documentChunks[readUUID] = this.documentChunks[readUUID] || Array.from({
                length: totalChunks
              }, function () {
                return null;
              });

              // Store each chunk in the corresponding index to preserve the order
              this.documentChunks[readUUID][currentChunk] = resultData;
              console.log("Received chunk ".concat(currentChunk, " for document ").concat(readUUID, ":"), resultData);

              // Directly process if there's only one chunk
              if (!(totalChunks === 1)) {
                _context5.next = 14;
                break;
              }
              console.log("Single chunk document ".concat(readUUID, " processed:"), resultData);
              this.trigger('documentScanned', resultData);
              delete this.documentChunks[readUUID]; // Clear memory after processing
              return _context5.abrupt("return");
            case 14:
              // Check if all chunks for this document have been received (for multiple chunks)
              if (this.documentChunks[readUUID].every(function (chunk) {
                return chunk !== null;
              })) {
                // Concatenate all received chunks
                fullData = this.documentChunks[readUUID].join('');
                console.log("Document ".concat(readUUID, " assembled from chunks:"), fullData);

                // Trigger the event with the complete data
                this.trigger('documentScanned', fullData);

                // Clear the stored chunks for this document to free up memory
                delete this.documentChunks[readUUID];
              }
            case 15:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function handleDocumentScan(_x2) {
        return _handleDocumentScan.apply(this, arguments);
      }
      return handleDocumentScan;
    }()
  }, {
    key: "init",
    value: function init() {
      _logger["default"].info("Initialization", "Regula module initialization started", "Regula");
      this.connection.on("messaging", this.handleMessage.bind(this));
    }
  }]);
}(_core["default"]);